import { getAddressSearchAsync } from "@store/hooks/useAddressSearch";
import { ADDRESS_VALIDATION_CODES, type AddressValidatorFunction } from "../../types";
import { Market } from "@config/site/types";
import { GlobalAddressMode } from "@interfaces/address/globalAddress";
import { parseAddressResult } from "./parseAddressResult";
import { getDeliveryMethodKey } from "@lib/utils/findDeliveryMethods";
import { ShippingMethodTypes } from "@features/checkout/types";
import { mapGlobalAddressToDeliveryAddress } from "@features/checkout/components/validation/address-validation/utils/mapGlobalAddressToDeliveryAddress";

export const validateAddressUS: AddressValidatorFunction = async ({
    address,
    shippingMethodId,
    checkoutType,
}) => {
    const deliveryMethodKey = getDeliveryMethodKey(shippingMethodId);
    if (
        [ShippingMethodTypes.CLICK_AND_COLLECT, ShippingMethodTypes.PARCEL_SHOP].includes(
            deliveryMethodKey as ShippingMethodTypes
        )
    ) {
        return {
            isValid: true,
        };
    }
    const result = await getAddressSearchAsync({
        country: Market.US,
        mode: GlobalAddressMode.VALIDATE,
        searchValue: {
            address1: address?.streetName,
            postalCode: address?.postalCode,
        },
    });

    // If the validation service has an error we want to warn the user
    if (result.error || !result.address) {
        return {
            isValid: false,
            action: "modal",
            error: {
                type: ADDRESS_VALIDATION_CODES.WARNING,
            },
        };
    }

    const resultAddress = mapGlobalAddressToDeliveryAddress(result.address);
    const parsedResult = parseAddressResult({
        enteredValues: address,
        validatedValues: resultAddress,
        checkoutType,
    });
    const hasErrors = Object.values(parsedResult.user).some(({ hasError }) => hasError === true);

    if (hasErrors) {
        return {
            isValid: false,
            action: "modal",
            error: {
                type: ADDRESS_VALIDATION_CODES.ADDRESS_SUGGESTION,
                data: {
                    addressSuggestion: resultAddress,
                },
            },
        };
    }

    return {
        isValid: true,
    };
};
